import { render, staticRenderFns } from "./DealFilters.vue?vue&type=template&id=51713514"
import script from "./DealFilters.vue?vue&type=script&lang=js"
export * from "./DealFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports